import React from "react";
import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import "@sbmdkl/nepali-datepicker-reactjs/dist/index.css";
import "nepali-datepicker-reactjs/dist/index.css";
import { Form, DatePicker } from "rsuite";

const IdentificationDetails = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Citizenship No.</Form.ControlLabel>
        <Form.Control name="Citizenship No." />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>District</Form.ControlLabel>
        <Form.Control name="District" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Citizenship Issued Date BS</Form.ControlLabel>
        <Form.Control
          accepter={Calendar}
          className="rs-input"
          name="Issued Date"
          format="YYYY-MM-DD"
          language="en"
          placement="auto"
        />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Citizenship Issued Date AD</Form.ControlLabel>
        <Form.Control
          accepter={DatePicker}
          name="Issued Date"
          className="w-full"
          format="YYYY-MM-DD"
          placement="auto"
        />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Identification Type</Form.ControlLabel>
        <Form.Control name="Identification Type" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Identification No.</Form.ControlLabel>
        <Form.Control name="Identification No." />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Identification Issued District</Form.ControlLabel>
        <Form.Control name="Issued District" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Identification Issued Date BS</Form.ControlLabel>
        <Form.Control
          accepter={Calendar}
          name="IssuedDate"
          className="rs-input"
          format="YYYY-MM-DD"
          language="en"
          placement="auto"
        />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Identification Issued Date AD</Form.ControlLabel>
        <Form.Control
          accepter={DatePicker}
          className="w-full"
          name="IssuedDateAD"
          format="YYYY-MM-DD"
          placement="auto"
        />
      </Form.Group>
    </div>
  );
};

export default IdentificationDetails;
